import { useEffect } from 'react';

interface SecurityHeadersConfig {
  enableCSP?: boolean;
  enableXFrameOptions?: boolean;
  enableXContentTypeOptions?: boolean;
  enableReferrerPolicy?: boolean;
}

export function useSecurityHeaders(config: SecurityHeadersConfig = {}) {
  useEffect(() => {
    // CSP is already defined in index.html - avoid duplication
    // X-Frame-Options and X-Content-Type-Options are also set in index.html
    
    // Only set Referrer Policy via JavaScript if needed
    if (config.enableReferrerPolicy !== false) {
      const meta = document.createElement('meta');
      meta.name = 'referrer';
      meta.content = 'strict-origin-when-cross-origin';
      document.head.appendChild(meta);
    }

    return () => {
      // Cleanup meta tags if needed
      const metas = document.querySelectorAll('meta[name="referrer"]');
      metas.forEach(meta => meta.remove());
    };
  }, [config]);
}